// Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

// Afidium
import { WORDING } from './config/wording';
import { ITemplate, ITemplateListLabels } from 'app_sasha/shared/interfaces/ITemplateList';

@Component({
    selector: 'template-list',
    template: `
        <card>
            <div class="card-header-content">
                <h1>{{ labels.modelsListCardHeader }}</h1>

                <div>
                    <back-button></back-button>
                    <btn [label]="labels.writeMessageWithoutTemplate"
                        (click)="onGoToFormView.emit()" type="actionDo"></btn>
                </div>
            </div>
            <div class="card-body-content card-marge-inside">
                <div class="field">
                    <label for="filterTemplates">{{ wording.labelInputFilterField }}</label>
                    <input type="text"
                        id="filterTemplates"
                        class="text-field"
                        [(ngModel)]="term">
                </div>
            </div>
        </card>

        <card>
            <div class="card-header-content">
                <h1>{{ wording.modelsList }}</h1>
            </div>
            <div class="card-body-content">
                <ng-content select="mail-list-top"></ng-content>

                <mat-nav-list *ngIf="templates && templates.length > 0 && !isLoading;"
                    [disableRipple]="true" class="list">
                    <mat-list-item
                        *ngFor="let template of templates | filter: term : filterOnProperty"
                        class="list-row e2e-btn-choice-model"
                        (click)="onSelectTemplate.emit(template)">
                        {{ template.name }}
                        <btn [label]="wording.choose" type="actionPrincipal">
                            {{ wording.chooseModel }}
                        </btn>
                    </mat-list-item>
                </mat-nav-list>

                <loader *ngIf="!templates.length || isLoading" [message]="wording.templatesLoading"></loader>
            </div>
        </card>
    `,
    styles: [`
        .list {
            padding-top: 0;
        }

        .list-row btn {
            opacity: 0;
        }

        .list-row:hover btn {
            opacity: 1;
        }

        .list .list-row ::ng-deep .mat-list-item-content {
            justify-content: space-between;
            padding: .75rem;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateListComponent {
    @Input()
    public templates: string[] = [];

    @Input()
    public isLoading: boolean = false;

    @Input()
    public labels: ITemplateListLabels = {
        writeMessageWithoutTemplate: WORDING.writeMessageWithoutTemplate,
        modelsListCardHeader: WORDING.modelsListCardHeader
    };

    @Output()
    public onSelectTemplate: EventEmitter<ITemplate> = new EventEmitter();

    @Output()
    public onGoToFormView: EventEmitter<null> = new EventEmitter();

    @Output()
    public onGoBack: EventEmitter<null> = new EventEmitter();

    public wording = WORDING;
    public filterOnProperty: string = 'name';
    public term: string = undefined;
}
